import * as React from 'react';
import cx from 'classnames';

import { FieldInputProps } from '../../types';

/**
 * The Text Input Component within a Bar.
 */
export interface IBarTextInputProps {
  /** Passed down classname. */
  className?: string;
  /** Optional id indicator */
  id?: string;
  /** Input props from react-final-form */
  input: FieldInputProps<HTMLElement>;
  /** Make this expand fully */
  isFullWidth?: boolean;
  /** Button has a white outline and text, the background color is dependant on parent */
  isReverse?: boolean;
  /** Optional placeholder */
  placeholder?: string;
}

export const BarTextInput: React.FC<IBarTextInputProps> = ({
  className,
  id,
  isFullWidth,
  isReverse = false,
  input: { name, onBlur, onChange, onFocus, value },
  placeholder,
}) => {
  const combinedClass = cx({
    'panda-bar-item': true,
    'panda-bar-item-text-input': true,
    'flex-align': true,
    'flex-1': isFullWidth,
    // Reverse style
    'panda-bar-item-normal': !isReverse,
    'panda-bar-item-reverse': isReverse,
    'text-ellipsis': true,
    // Custom classname
    [className || '']: true,
  });

  return (
    <input
      autoComplete="off"
      className={combinedClass}
      id={id}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={placeholder}
      type="text"
      value={value}
    />
  );
};
